import type { AxiosError } from 'axios';
import axios from 'axios';
import posthog from 'posthog-js';

import config from '../config/config';
import type { CheckAbilityDto } from '../types';
import baseUrlUtil from '../util/base-url-util';

declare const VERSION: string;

const checkAvailability = async (team?: string, category?: string, agentName?: string): Promise<CheckAbilityDto> => {
  try {
    const apiBaseUrl = config.publicApi.enabled ? `${config.publicApi.url}` : `${config.api.url}`;

    const response = await axios<{ data: CheckAbilityDto }>({
      data: {
        agentUsername: agentName,
        category,
        storeBaseUrl: baseUrlUtil.getBaseUrl(),
        team
      },
      method: 'post',
      url: `${apiBaseUrl}/api/v2/sessions/check-availability/`
    });
    return response.data.data;
  } catch (e) {
    const error = e as AxiosError;
    posthog?.capture('checkAvailabilityFailed', { agentName, category, error: error.toJSON(), team, version: VERSION });
    console.error(`check availability failed, error:${(e as AxiosError).message}`);
    return { isAgentsOnline: false, noOfAvailableAgents: 0 };
  }
};
// @ts-ignore
window.checkAvailability = checkAvailability;
export default checkAvailability;
